import { render, staticRenderFns } from "./MessageSearchPageNav.vue?vue&type=template&id=5b084126"
import script from "./MessageSearchPageNav.vue?vue&type=script&lang=js"
export * from "./MessageSearchPageNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports